<template>
  <div class="home _width">
    <Header></Header>

    <!-- conter -->
    <div class="conter_wp _width">
      <!-- 居中 -->
      <div class="wrap loginBox">
        <div class="flex_conter">
          <!-- 切换头部 -->
          <div class="topBar_lb">
            <img src="@/assets/image/logo.png" alt="" />
          </div>
          <!-- 切换头部 end-->

          <div class="login_conter">
            <!-- 登录 -->
            <div class="mainBox login-box" v-if="this.$route.query.state == 1">
              <div class="loginMain clearfix">
                <div class="loginMain-right">
                  <h2>登录</h2>
                  <div class="loginInfo">
                    <p class="loginTip">{{ login_tips }}</p>
                    <!-- <p class="loginTip"
                     v-if="phone_code.state == 202">{{phone_code.msg}}</p> -->
                    <!-- 手机号 -->
                    <div class="_width login_icon" style="margin-top: 0">
                      <div class="icon">
                        <img src="@/assets/image/login/download.png" alt="" />
                      </div>

                      <form>
                        <input
                          type="text"
                          v-model="login_data.phone"
                          class="userNameInput fl"
                          autocomplete="off"
                          placeholder="手机号码"
                        />
                      </form>
                    </div>

                    <input type="hidden" class="targetUrl" />

                    <!-- 密码 -->
                    <div class="_width login_icon">
                      <div class="icon">
                        <img src="@/assets/image/login/download-1.png" alt="" />
                      </div>
                      <form>
                        <input
                          type="password"
                          autocomplete="off"
                          v-model="login_data.password"
                          class="passwordInput fl"
                          placeholder="密码"
                        />
                      </form>
                    </div>

                    <!-- 验证码 -->
                    <div class="verifyBar fl">
                      <input
                        type="text"
                        placeholder="验证码"
                        id="identifyCode"
                        v-model="login_data.phone_code"
                        style="
                          padding-left: 10px;
                          width: 260px;
                          margin-right: 10px;
                        "
                      />
                      <!-- src="https://v.jingjiribao.cn/verifycode/getcode?0.12873768231976834" -->
                      <img
                        src="https://v.jingjiribao.cn/verifycode/getcode?0.12873768231976834"
                        class="identifyImg"
                        @click="on_code()"
                        style="
                          width: 131px;
                          height: 50px;
                          border: 0;
                          vertical-align: middle;
                        "
                        v-if="!code_url"
                      />

                      <img
                        :src="code_url"
                        v-else
                        class="identifyImg"
                        @click="on_code()"
                        style="
                          width: 131px;
                          height: 50px;
                          border: 0;
                          vertical-align: middle;
                        "
                      />
                    </div>
                    <div class="funBar _width">
                      <input type="checkbox" v-model="login_data.checked" />

                      <label>记住密码</label>
                      <div class="funBar_right">
                        <router-link
                          class="findPswLink"
                          title="点击找回密码"
                          to="/forget_pwd"
                          >忘记密码？
                        </router-link>

                        <span> |</span>
                        <router-link to="/login?state=2" class="goToRegister"
                          >注册</router-link
                        >
                      </div>
                    </div>
                    <!-- 登录按钮 -->
                    <input
                      type="button"
                      class="loginBtn fl _width"
                      value="登录"
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      @click="login_commit()"
                      :disabled="isDisable"
                    />
                    <!-- <div class="tipBar fl _width">还没有账户？点击此处去
                    <router-link to="/login?state=2"
                                 class="goToRegister">注册</router-link>
                  </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- 注册 -->
            <div class="mainBox regist-box" v-if="this.$route.query.state == 2">
              <div class="loginMain clearfix">
                <div class="loginMain-right fl">
                  <h2>注册</h2>
                  <div class="registerInfo">
                    <!-- 报错提示 -->
                    <p class="loginTip">{{ tips }}</p>
                    <!-- 手机号  @focus="focus_on(resigin.phone,'focus')"-->
                    <form>
                      <input
                        type="text"
                        v-model="resigin.phone"
                        @blur="focus_on(resigin.phone, 'blur')"
                        placeholder="手机号"
                        ref="focus_phone"
                        autocomplete="off"
                        class="telInput fl _width"
                      />
                    </form>

                    <!-- 验证码 -->
                    <div style="margin-top: 0.25rem" class="verifyBar2">
                      <input
                        type="text"
                        placeholder="手机验证码"
                        id="verifyNum"
                        autocomplete="off"
                        v-model="resigin.code"
                        :class="disabled_resigin == false ? 'curp' : ''"
                        ref="focus_code"
                        :disabled="disabled_resigin == false"
                        class="fl"
                        style="width: 260px"
                      />
                      <button
                        class="verifyBtn fl"
                        v-if="disabled_resigin == false"
                        :class="disabled_resigin == false ? 'curp' : ''"
                        :disabled="disabled_resigin == false"
                      >
                        获取验证码
                      </button>
                      <button
                        class="verifyBtn fl"
                        v-else
                        @click="on_phone_code"
                      >
                        {{ item_code }}
                      </button>
                    </div>

                    <!-- 密码 -->
                    <form class="password_first_box">
                      <div style="height: 1rem; clear: both">
                        <input
                          style="margin-top: 0.25rem; margin-bottom: 0.05rem"
                          type="password"
                          autocomplete="off"
                          placeholder="密码须包含大小写字母、数字和特殊字符，长度至少8位"
                          class="password_first fl"
                          v-model="resigin.password"
                          ref="focus_password"
                          @keyup="passwordCheck"
                          @blur="passwordBlur"
                          maxlength="20"
                        />
                        <p class="pwdColor">
                          <span class="c1"></span>
                          <span class="c2"></span>
                          <span class="c3"></span>
                        </p>
                        <p class="pwdText">
                          <span>弱</span>
                          <span>中</span>
                          <span>强</span>
                        </p>
                        <p
                          class="error-tip"
                          style="color: red; font-size: 14px; margin-top: 5px"
                        ></p>
                      </div>
                    </form>
                    <form>
                      <input
                        style="margin-top: 0"
                        type="password"
                        v-model="resigin.password_s"
                        ref="focus_password_s"
                        placeholder="请确认与新密码保持一致"
                        autocomplete="off"
                        class="password_sed fl"
                        maxlength="20"
                      />
                    </form>
                    <!-- 阅读协议 -->
                    <div
                      style="margin-top: 0.25rem"
                      class="checkboxBar clearfix fl"
                    >
                      <input
                        type="checkbox"
                        ref="focus_check"
                        v-model="resigin.check"
                      />
                      <label>我已阅读并同意</label>
                      <a
                        href="https://v.jingjiribao.cn/pages/useragreement.html"
                        target="_blank"
                        title="user"
                        style="color: rgb(0, 120, 215)"
                        >《中经视觉用户协议》</a
                      >与
                      <a
                        href="https://v.jingjiribao.cn/pages/perinfopolicy.html"
                        target="_blank"
                        title="person"
                        style="color: rgb(0, 120, 215)"
                        >《中经视觉个人信息保护政策》</a
                      >
                    </div>

                    <!-- 注册按钮 -->
                    <input
                      type="button"
                      class="registerBtn fl"
                      value="注册"
                      @click="registerBtn()"
                    />

                    <!-- <input
                      type="button"
                      class="registerBtn fl"
                      value="注册"
                      v-ripple="'rgba(255, 255, 255, 0.25)'"
                      :class="disabled_resigin == false ? 'btn_null' : ''"
                      :disabled="disabled_resigin_submit == false"
                    /> -->

                    <div class="tipBar fl _width">
                      已有账号，返回
                      <router-link to="/login?state=1" class="goToLogin"
                        >登录</router-link
                      >
                    </div>
                  </div>
                </div>
                <!-- mainBox end -->
              </div>
            </div>

            <p class="loginTips _width">
              提示：为提升浏览体验与质量，建议使用Firefox、Chrome浏览器或360浏览器极速模式。
            </p>
          </div>
        </div>
      </div>

      <!-- 居中 end-->
    </div>
    <!-- conter end -->

    <!-- 已经登陆 -->
    <div class="mose" :class="is_login_show == true ? 'show' : ''">
      <div class="url">
        <p>你已经登录网站</p>
        <a href="javascript:;">{{ count_2 }}后自动跳转页面</a>
      </div>
    </div>

    <!-- <Footer></Footer> -->
    <is_http></is_http>
  </div>
</template>

<script>
import is_http from "@/components/common/is_http.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import RSAUtilsFun from "../../../static/js/security.js";
import $ from "jquery";
import crypto from "../../assets/js/crypto";
import {
  doLogin,
  post_phone_code,
  Info,
  testing_phone,
  sendMessage,
  doReg_resigin,
  me_key,
  getInitParams,
} from "@/utils/api/login.js";
export default {
  name: "login",
  data() {
    return {
      // tab: 0,//默认登录tab 切换
      isDisable: false, ///禁止点击
      topHeight: "",

      // 登录----------
      login_tips: "", //登录提示
      phone_code: {}, //验证码
      // 登录传递的值
      login_data: {
        phone: "", //手机号
        password: "", //密码
        phone_code: "", //验证码
        checked: false, //记住密码
      },
      code_url: "", //二维码地址

      // 登录后提示
      is_login_show: false,
      count_2: "", //倒计时

      // 注册-------------
      // 报错提示
      tips: "",
      // 发送验证码
      item_code: "发送验证码",
      timer: null,

      resigin: {
        phone: "", //手机号
        code: "", //手机验证码
        password: "", //密码
        password_s: "", //再次输入密码
        check: false, //同意协议
      },

      // 控制焦点
      // focus_password_s:
      testing: [], //验证手机号
      disabled_resigin: false, //false 注册不可点击  true 注册可以点击

      // 私钥
      key: {},
      do_loginUser: {}, //登录后的信息
      code_type: 0,
      path: this.URL.home,
      // 登录失误最大次数
      loginErrCount: 3,
      // 登录失败按钮锁定时间
      loginButtonUntieTime: "5",
      timeOut: 0,
    };
  },
  watch: {
    topHeight(val) {
      this.topHeight = val;
    },
  },

  created() {
    this.is_login(); //是否登陆
    // 登录获取初始化参数
    this.getInitParams();
    this.loginInit();
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.topHeight = this.windowHeight - 0 + "px";
    window.onresize = () => {
      return (() => {
        this.windowHeight = window.innerHeight;
        this.topHeight = this.windowHeight - 0 + "px";
      })();
    };
    this.getCookie(); //读取cookie
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },

  methods: {
    passwordBlur() {
      var newRegexp = new RegExp("[+%]");
      var newRegexp1 = /\\/g;
      if (this.resigin.password == "") {
        $(".pwdColor").hide();
        $(".pwdText").hide();
        $(".password_first").siblings("p.error-tip").html("");
        return;
      }
      if (newRegexp.test(this.resigin.password)) {
        $(".pwdColor").hide();
        $(".pwdText").hide();
        $(".password_first").siblings("p.error-tip").css("display", "block");
        $(".password_first")
          .siblings("p.error-tip")
          .html("密码中请不要使用+ % \\ ！");
      } else if (newRegexp1.test(this.resigin.password)) {
        $(".pwdColor").hide();
        $(".pwdText").hide();
        $(".password_first").siblings("p.error-tip").css("display", "block");
        $(".password_first")
          .siblings("p.error-tip")
          .html("密码中请不要使用+ % \\ ！");
      } else {
        $(".password_first").siblings("p.error-tip").css("display", "none");
        $(".password_first").siblings("p.error-tip").html("");
        $(".pwdColor").show();
        $(".pwdText").show();
      }
    },
    // 获取登录错误次数不能被页面刷新清空。倒计时不能被页面刷新清空。页面刷新后要延续没有走完的倒计时。
    loginInit() {
      // 判断是否第一次登录
      // if (window.localStorage.getItem("loginNum")) {
      if (this.$cookie.get("loginNum")) {
        // var errorTimes = window.localStorage.getItem("loginNum");
        var errorTimes =
          (this.$cookie.get("loginNum") && this.$cookie.get("loginNum")) || 1;
        // 判断是否登录失败了5此
        if (errorTimes >= this.loginErrCount) {
          // 禁用按钮
          this.$nextTick(() => {
            $(".loginBtn").attr("disabled", true);
            // 进入页面的时间
            var nowTime = parseInt(new Date().getTime() / 1000);
            // 判断是否存在倒计时
            // if (window.localStorage.getItem("timestamp")) {
            if (this.$cookie.get("timestamp")) {
              // 输入超过5此失败被限制的时间
              // var timestamp = window.localStorage.getItem("timestamp");
              var timestamp = this.$cookie.get("timestamp");
              // 判断倒计时是否结束
              if (timestamp >= 0) {
                // 过去的时间
                var ms = nowTime - timestamp;
                // 剩余的时间
                this.timeOut = this.loginButtonUntieTime * 60 - ms;
                // 判断倒计时是否结束
                let _this = this;
                if (this.loginButtonUntieTime * 60 * 1000 > this.timeOut) {
                  var auth_timetimer = setInterval(function () {
                    _this.timeOut--;
                    $(".loginBtn").val(_this.timeOut + "s");
                    if (_this.timeOut <= 0) {
                      $(".loginBtn").val("登录");
                      $(".loginBtn").attr("disabled", false);
                      // window.localStorage.removeItem("loginNum");
                      this.$cookie.remove("loginNum");
                      clearInterval(auth_timetimer);
                    }
                  }, 1000);
                }
              }
            } else {
              $(".loginBtn").attr("disabled", false);
              // window.localStorage.removeItem("loginNum");
              this.$cookie.remove("loginNum");
            }
          });
        }
      }
    },
    // 判断登录按钮是否锁定
    judgeLoginError() {
      // 取出登录失败的次数
      // var errorTimes = window.localStorage.getItem("loginNum");
      var errorTimes =
        (this.$cookie.get("loginNum") && this.$cookie.get("loginNum")) || 1;
      // 失败超过5次
      if (errorTimes >= this.loginErrCount) {
        // 禁用按钮
        // this.$alert(
        //   "用户名或密码错误！您的账号被锁定，请" +
        //     this.loginButtonUntieTime +
        //     "分钟后重试。",
        //   {
        //     confirmButtonText: "确定",
        //   }
        // );
        this.$message({
          message:
            "用户名或密码错误！您的账号被锁定，请" +
            this.loginButtonUntieTime +
            "分钟后重试。",
          type: "warning",
        });
        $(".loginBtn").attr("disabled", true);
        // 获取触发时间获取超次数时间并保存
        var timestamp = parseInt(new Date().getTime() / 1000);
        this.$cookie.set("timestamp", timestamp, 5);
        // window.localStorage.setItem("timestamp", timestamp);
        // 页面显示倒计时59秒
        this.timeOut = this.loginButtonUntieTime * 60;
        let _this = this;
        var auth_timetimer = setInterval(function () {
          _this.timeOut--;
          $(".loginBtn").val(_this.timeOut + "s");
          if (_this.timeOut <= 0) {
            //关闭禁用登录状态
            $(".loginBtn").val("登录");
            $(".loginBtn").attr("disabled", false);
            //清空登录错误次数
            // window.localStorage.removeItem("loginNum");
            this.$cookie.remove("loginNum");
            //清除倒计时
            clearInterval(auth_timetimer);
          }
        }, 1000);
      } else {
        // 判断处理loginNum为undenfind的情况
        errorTimes++;
        //存储密码错误次数
        this.$cookie.set("loginNum", errorTimes, 5);
        // window.localStorage.setItem("loginNum", errorTimes);
      }
    },
    // 获取初始化参数接口
    getInitParams() {
      getInitParams().then((res) => {
        localStorage.setItem("aesIv", res.data.data.aesIv);
        localStorage.setItem("aesKey", res.data.data.aesKey);
        this.loginErrCount = res.data.data.loginErrCount;
        this.loginButtonUntieTime = res.data.data.loginButtonUntieTime;
      });
    },
    // 是否登录
    is_login() {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin;
        if (this.isLogin == true) {
          this.login_ing(); //进行自动跳转事件
          this.is_login_show = true; //显示http弹窗
        }
      });
    },
    //几秒后进入跳转页面
    login_ing() {
      const time = 3;
      if (!this.timer) {
        this.count_2 = time;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count_2 > 0 && this.count_2 <= time) {
            this.count_2--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            //跳转的页面写在此处
            // this.$router.push({ path: '/address' });
            // location.href = 'https://v.jingjiribao.cn/newcommunity/#/login?state=1'

            // 判断需要登陆的 功能来源 活动详情
            let router_url_url = sessionStorage.getItem("router_url");
            if (router_url_url && router_url_url !== undefined) {
              this.$router.push({ path: router_url_url }); //跳转至来源的页面
              sessionStorage.removeItem("router_url"); //清空活动详情的的储存
              return false;
            } else {
              // console.log('跳转页面 默认');
              // this.$router.push({ path: 'https://v.jingjiribao.cn/newcommunity/#/activity_index/' })//跳转页面 默认

              window.location.href =
                "https://v.jingjiribao.cn/newcommunity/#/activity_index/";
            }
          }
        }, 1000);
      }
    },

    // 切换登录注册
    // on_tab (index) {
    //   this.tab = index;
    //   if (index == 1) {
    //     this.$router.push(
    //       {
    //         path: '/login?state=1'
    //       }
    //     )
    //   } else if (index == 2) {
    //     this.$router.push(
    //       {
    //         path: '/login?state=2'
    //       }
    //     )
    //   }
    // },
    // this.post_phone_code();

    // 登录模块--------------------------------------------------------------------------

    // 登录按钮
    login_commit() {
      // 防止重复点击  时间1s
      // this.isDisable = true;
      // setTimeout(() => {
      //   this.isDisable = false;
      // }, 2000); //
      if (this.login_data.phone.length <= 0) {
        this.login_tips = "请输入手机号";
        return;
      }

      if (this.login_data.password.length <= 0) {
        this.login_tips = "请输入密码";
        return;
      }

      if (this.login_data.phone_code.length <= 0) {
        this.login_tips = "请输入验证码";
        return;
      }

      const that = this;
      //判断复选框是否被勾选 勾选则调用配置cookie方法
      if (that.login_data.checked == true) {
        // console.log("checked == true");
        //传入账号名，密码，和保存天数3个参数
        that.setCookie(that.login_data.phone, that.login_data.password, 7);
      } else {
        // console.log("清空Cookie");
        //清空Cookie
        that.clearCookie();
      }

      let params_code = {
        code: this.login_data.phone_code,
      };
      // 正式 环境 执行登录事件
      this.post_phone_code(params_code); //请求验证码接口 进行登录

      // 线下无法正常走验证码 用此步骤
      // let params = {
      //   username: this.login_data.phone,
      //   password: this.login_data.password,
      //   verifycode: this.login_data.phone_code
      // }
      // this.login(params)//执行登录事件
    },
    // 点击回车键登录
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13 || e.keyCode == 100) {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        if (query.state == 1) {
          // 登录
          this.login_commit();
        } else {
          // 注册
          this.registerBtn();
        }
      }
    },

    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "phone" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示格式需要切割一下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "phone") {
            this.login_data.phone = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "password") {
            this.login_data.password = arr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },

    //发送验证码
    async post_phone_code(name) {
      let { data } = await post_phone_code(name);
      this.phone_code = data;
      // console.log(this.phone_code)
      if (data.state == 200) {
        let params = {
          username: this.login_data.phone,
          //密码加密传输
          password: crypto.encrypt(this.login_data.password),
          verifycode: this.login_data.phone_code,
        };
        var phoneReg = /^1\d{10}$/;
        // 如果用户名为手机号则需要加密
        if (phoneReg.test(params.username)) {
          params.username = crypto.encrypt(params.username);
        }
        this.login(params); //执行登录事件
      } else {
        this.login_tips = data.msg;
        // this.judgeLoginError();
        return false;
      }
    },

    // 登录 以及  登录后的信息
    login(params) {
      this.login_tips = "";
      doLogin(params).then((res) => {
        this.loading_bool = true;
        let data = res.data;
        this.do_loginUser = data.user;

        if (data.status == 200) {
          this.$store.commit("id", this.do_loginUser.id);
          sessionStorage.setItem("id", this.do_loginUser.id);
          sessionStorage.setItem("headimg", this.do_loginUser.headimg);
          sessionStorage.setItem("realname", this.do_loginUser.realname);
          // console.log('登录页面是否接收到需要跳转的的路径', this.$route.query.redirect);

          // 如果是从别人主页来的   id和登录的userId一样 就进入自己空间  否则就进入别人主页
          let userId = sessionStorage.getItem("userId");
          let id = sessionStorage.getItem("id");
          if (userId && userId !== "" && id && id !== "") {
            if (userId == id) {
              // 自己主页
              this.$router.push({ path: "/Pcenter?type=0" });
              return false;
            } else {
              // 别人主页
              this.$router.push({ path: "/Ucenter/" + userId });
              return false;
            }
          }

          // 判断需要登陆的 功能来源 活动详情
          let router_url_url = sessionStorage.getItem("router_url");
          if (router_url_url) {
            this.$router.push({ path: router_url_url }); //跳转至来源的页面
            sessionStorage.removeItem("router_url"); //清空活动详情的的储存
            return false;
          }

          // 如果是页面需要登录
          if (this.$route.query.redirect) {
            // console.log('/跳转至来源的页面');
            // console.log(this.$route.query.redirect);
            // return false
            this.$router.push({ path: this.$route.query.redirect }); //跳转至来源的页面
            return false;
          } else {
            //   // console.log('跳转页面 默认');
            // this.$router.push({path: '/',})
            // this.$router.push({ path: this.$route.query.redirect })//跳转至来源的页面
            window.location.href =
              "https://v.jingjiribao.cn/newcommunity/#/activity_index/";
          }
        } else {
          // 登录失败次数
          var errorTimes =
            (this.$cookie.get("loginNum") && this.$cookie.get("loginNum")) || 1;
          // 剩余登录次数
          var loginNum = this.loginErrCount - errorTimes;
          if (loginNum > 0) {
            this.login_tips = data.msg + "您剩余 " + loginNum + " 次重试机会！";
          } else {
            this.login_tips = data.msg;
          }

          this.judgeLoginError();
          return false;
        }
      });
    },

    // 更换验证码
    on_code() {
      // let schid = SchoolConfig.getSchid();//schid地址
      var timestamp = new Date().getTime(); //时间戳
      // var rand = Math.floor(Math.random() * 10000);//四位随机数
      // var uuid = md5(schid + timestamp + rand);//md5加密
      this.code_url =
        "https://v.jingjiribao.cn/verifycode/getcode?" + timestamp; //图片验证
      // this.code_url = 'http://192.168.3.12:8080/verifycode/getcode?' + timestamp
      //图片验证
      // console.log(this.code_url);
    },

    // 注册部分-------------------------------------------------------------------------
    // 手机号焦点事件 触发验证
    focus_on(name, type) {
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (name == "" || name == undefined || name == null) {
        this.tips = "请输入手机号";
        // this.$refs.focus_phone.focus()
        return;
      } else {
        if (!reg.test(name) && name !== "") {
          this.tips = "请输入正确的电话号码";
          // this.$refs.focus_phone.focus()
          return;
        } else {
          let params = { phone: name };
          this.testing_phone(params); //验证手机号
        }
      }
    },
    // 发送手机验证码
    on_phone_code(code_type) {
      // this.item_code = ''
      const time_out = 60;
      if (!this.timer) {
        this.item_code = time_out;
        // this.show = false;
        this.timer = setInterval(() => {
          if (this.item_code > 0 && this.item_code <= time_out) {
            this.item_code--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.disabled_resigin = true;
            this.item_code = "获取验证码";
          }
        }, 1000);
        let params = { phone: this.resigin.phone };
        this.sendMessage(params); //验证手机号
      }
    },

    // 发送手机验证码
    async sendMessage(name) {
      let { data } = await sendMessage(name);
      // this.testing = data;
      console.log(data);
    },

    // 验证手机号
    async testing_phone(name) {
      let { data } = await testing_phone(name);
      this.testing = data;
      if (this.testing.status == 301) {
        this.tips = "该手机号已经注册";
        this.disabled_resigin = false; //注册按钮不可以点击
        return;
      } else if (this.testing.status == 300) {
        this.disabled_resigin = true; //注册按钮可以点击
        this.tips = ""; //清空提示
      }
      // console.log(this.testing)
    },
    passwordCheck() {
      if (this.resigin.password == "") {
        $(".pwdColor").hide();
        $(".pwdText").hide();
      } else {
        $(".password_first").siblings("p.error-tip").css("display", "none");
        $(".password_first").siblings("p.error-tip").html("");
        $(".pwdColor").show();
        $(".pwdText").show();
      }
      this.checkpwd();
    },
    //全部都是灰色的
    primary() {
      $("p.pwdColor span").removeClass("co1,co2,co3");
    },
    //密码强度为弱的时候
    weak() {
      $("span.c1").addClass("co1");
      $("span.c2").removeClass("co2");
      $("span.c3").removeClass("co3");
    },
    //密码强度为中等的时候
    middle() {
      $("span.c1").addClass("co1");
      $("span.c2").addClass("co2");
      $("span.c3").removeClass("co3");
    },

    //密码强度为强的时候
    strong() {
      $("span.c1").addClass("co1");
      $("span.c2").addClass("co2");
      $("span.c3").addClass("co3");
    },
    /**判断密码的强弱规则
    1、如果是单一的字符（全是数字 或 字母 ）长度小于 6  弱
    2、如果是两两混合 (数字+字母（大小） 或 数字+特殊字符  或 特殊字符+字母  长度大于 8  中)
    3、如果是三者组合 (数字 +大写字母+小写字母 或 数字+字母+特殊字符 长度>8  强）)
  **/
    //密码强弱判断函数
    checkpwd() {
      var txt = this.resigin.password.trim(); //输入框内容 trim处理两端空格
      var len = txt.length;
      var num = /\d/.test(txt); //匹配数字
      var small = /[a-z]/.test(txt); //匹配小写字母
      var big = /[A-Z]/.test(txt); //匹配大写字母
      var corps = /\W/.test(txt); //特殊符号
      var val = num + small + big + corps; //四个组合

      if (len < 1) {
        this.primary();
      } else if (len < 8) {
        if (val == 1) {
          this.weak();
        } else if (val == 2) {
          this.middle();
        }
      } else if (len >= 8) {
        if (val == 1) {
          this.weak();
        } else if (val >= 2 && val < 4) {
          this.middle();
        } else if (val == 4) {
          this.strong();
        }
        return false;
      }
    },
    // 私钥
    async me_key(name) {
      let { data } = await me_key(name);
      this.key = data;
      var keys = "";
      console.log(this.key);
      if (data.state == 200) {
        RSAUtilsFun.RSAUtils.setMaxDigits(130);
        keys = new RSAUtilsFun.RSAUtils.getKeyPair(
          data.publicKeyExponent,
          "",
          data.publicKeyModulus
        );
        console.log(keys);
        return keys;
      }
    },

    // 注册账号按钮 验证是 为空和密码是否一致 是否同意协议
    async registerBtn() {
      // var pwdRegex = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/;
      var pwdRegex =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/;
      var newRegexp = new RegExp("[+%]");
      var newRegexp1 = /\\/g;
      if (this.resigin.phone.length <= 0) {
        this.tips = "请输入手机号";
        this.$refs.focus_phone.focus();
      } else if (this.resigin.code.length <= 0) {
        this.tips = "请输入手机验证码";
        this.$refs.focus_code.focus();
        return false;
      } else if (this.resigin.password.length <= 0) {
        this.tips = "请输入密码";
        this.$refs.focus_password.focus();
        return false;
      } else if (!newRegexp.test(this.resigin.password)) {
        this.tips = "密码中请不要使用+ % \\ ！";
        this.$refs.focus_password.focus();
        return false;
      } else if (!newRegexp1.test(this.resigin.password)) {
        this.tips = "密码中请不要使用+ % \\ ！";
        this.$refs.focus_password.focus();
        return false;
      } else if (!pwdRegex.test(this.resigin.password)) {
        this.tips = "密码须包含大小写字母、数字和特殊字符，长度至少8位";
        this.$refs.focus_password.focus();
        return false;
      } else if (this.resigin.password_s.length <= 0) {
        this.tips = "请确认密码";
        this.$refs.focus_password_s.focus();
        return false;
      } else if (this.resigin.password != this.resigin.password_s) {
        this.tips = "请确保两次输入的密码一致！";
        this.$refs.focus_password.focus();
        this.$refs.focus_password_s.focus();
        return false;
      } else if (this.resigin.check == false) {
        this.tips = "请同意用户协议";
        this.$refs.focus_check.focus();
        return false;
      }
      this.disabled_resigin = true; //注册按钮可以点击
      this.tips = "";
      this.me_key().then((resKeyData) => {
        var password_m = RSAUtilsFun.RSAUtils.encryptedString(
          resKeyData,
          encodeURIComponent(this.resigin.password)
        );
        let params = {
          code: this.resigin.code,
          username: this.resigin.phone,
          phone: this.resigin.phone,
          password: password_m,
          pwdreg: password_m,
        };
        // // this.getEncrypted(this.resigin.password);
        this.doReg_resigin(params); //注册接口
      });
      // this.me_key((resKeyData) => {
      //   console.log(resKeyData, "resKeyDataresKeyData");
      //   console.log(encodeURIComponent(this.resigin.password), "2222");
      // });
    },

    // 注册
    async doReg_resigin(name) {
      let { data } = await doReg_resigin(name);
      // this.tips = data.msg//验证码不正确 或者未输入验证码
      console.log(data.data);
      if (data.data.code !== 200) {
        this.tips = data.data.message;
        return false;
      }
      // if (data.code == 302) {
      //   this.tips = '手机号已经存在'
      //   return false;
      // }
      // if (data.code == 305) {
      //   this.tips = '两次密码输入不一致！'
      //   return false;
      // }
      // if (data.code == 306) {
      //   this.tips = '密码长度不匹配或含有非法字符'
      //   return false;
      // }
      // if (data.code == 201) {
      //   this.tips = '验证码为空或验证码已经过期！'
      //   return false;
      // }
      // if (data.code == 202) {
      //   this.tips = '验证码输入错误，请重新输入！'
      //   return false;
      // }
      else {
        this.$message({
          message: "恭喜你，注册成功",
          type: "success",
        });
        (this.resigin.phone = ""),
          (this.resigin.phone_code = ""),
          (this.resigin.password = ""),
          (this.resigin.password_s = ""),
          this.resigin.check == false;

        this.$router.push({ path: "/login?state=1" }); //跳转页面 默认
        return;
      }
    },
  },
  components: {
    Header,
    Footer,
    is_http,
  },
};
</script>
<style scoped>
@import "../../assets/css/login/login.css";
.home >>> .header_fxed {
  background: none;
  background-image: none;
  border: none;
  box-shadow: none;
  backdrop-filter: blur(0) !important;
}
.home >>> .login_hide {
  display: none !important;
}
.conter_wp {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 750px;
}
.home {
  position: relative;
  background-size: 100%;
  background-image: url(../../assets/image/banner/login.png);
}
.wrap {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 1rem;
  box-sizing: border-box;
  /* align-items: center; */
}
/* .loginBox .topBar_lb */

/* 登录后 */
.mose {
  display: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.show {
  display: block;
}
.url {
  width: 35%;
  padding: 30px 10px;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.url p {
  color: #333;
  font-size: 0.16rem;
  text-align: center;
  margin-bottom: 0.2rem;
}
.url a {
  color: #d4011a;
  display: block;
  margin-top: 10px;
  text-align: center;
}
p.pwdColor {
  width: 150px;
  height: 5px;
  margin-top: 6px;
  margin-left: 2px;
  display: none;
  clear: both;
}

p.pwdColor span {
  display: inline-block;
  width: 40px;
  height: 4px;
  float: left;
  margin-right: 10px;
  background: #ccc;
}

p.pwdText {
  margin-left: 2px;
  display: none;
}

p.pwdText span {
  margin-right: 20px;
  margin-left: 13px;
  font-size: 12px;
  color: #ddd;
}

p.pwdColor span.co1 {
  background: #f00;
}

p.pwdColor span.co2 {
  background: #00ff66;
}

p.pwdColor span.co3 {
  background: #0033cc;
}
.loginBtn[disabled] {
  cursor: not-allowed !important;
  /* background: rgba(255, 255, 255, 0.25); */
  opacity: 0.65;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue